import script from "./CountUp.vue?vue&type=script&setup=true&lang=js"
export * from "./CountUp.vue?vue&type=script&setup=true&lang=js"

import "./CountUp.vue?vue&type=style&index=0&id=661cef38&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-661cef38"]])

export default __exports__